import React from "react";

export default function ErrorMessage({ msg }) {
    return <span className="text-danger">* {msg}</span>
}